import "Layouts/default";

import { updateLazy } from "Functions/lazy";
import { scrollToEl } from "Functions/anchor";
import { initTippy } from "Functions/tippy";

import "Ui/slider";
import "Ui/favorite-trigger";

import "Components/modal/modal-remote";

import "./catalog-jquery";
import "./filter-slider";
import "./filter-bubbles";
import "./filter-sync";
import "./age-popup";

const attachPaginatorEvents = () => {
    for (const pagerButton of document.querySelectorAll(".pager__list .c-btn")) {
        if (pagerButton.classList.contains("is-active")) continue;

        pagerButton.addEventListener("click", (event) => {
            scrollToEl(document.querySelector(".js-listing-scroll-here"), 20);
        });
    }
};

rEvent.on("Listing.fetchedData", () => {
    updateLazy();
    attachPaginatorEvents();
    initTippy();

    if ($(".js-pager-current-count").length) {
        $(".js-pager-current-count").html(
            $(".listing.products").first().find(".products__item").length
        );
    }
});

attachPaginatorEvents();

const filterHolderEl = document.getElementById("filter-holder");
if (filterHolderEl) {
    filterHolderEl.addEventListener("rToggle.afterOpen", () => {
        const rTabs = filterHolderEl.querySelector("r-tabs");

        if (rTabs && !rTabs.activeTabs.length) {
            rTabs.openTab(rTabs.targets[0].id);
        }
    });

    document.querySelector(".js-filter-show-results").addEventListener("click", () => {
        scrollToEl(document.querySelector(".js-listing-scroll-here"), 20);
    });
}

const filterEl = document.getElementById("filter");
if (filterEl !== null) {
    filterEl.addEventListener("category.changed", function (e) {
        const categoryId = e.detail.category_id;
        const filterCategoryIdInput = document.getElementById("filterCategoryId");

        if (filterCategoryIdInput) {
            filterCategoryIdInput.value = categoryId;
        }

        Filter.submit();
    });
}
